import React, { useEffect, useState } from "react";
import axios from "axios";
import * as ReactBootstrap from "react-bootstrap";
import ProgressBar from "react-bootstrap/ProgressBar";
import Editbtn from "../Skills/images/circum_edit.svg";
import { Pagination } from "react-bootstrap";
import deletebtn from "../Skills/images/material-symbols-light_delete-outline.svg";
import stepbtn from "../Skills/images/step_btn.svg";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { baseURL } from "../../config";

const AppealApprovalTable = () => {
  const [posts, setPosts] = useState({ appeals: [] });
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(10);
  const [hideAppealbuttons, setHideAppealButtons] = useState(false);
  const id = localStorage.getItem("employeeid");
  const isAppealcommiteeMember = localStorage.getItem(
    "appealcommiteememberstatus"
  );

  const [showModal, setShowModal] = useState(false);
  const [employeeId, setEmployeeId] = useState("");
  const [requestId, setRequestId] = useState("");
  const [action, setAction] = useState("");
  const [showStatustext, setShowStatustext] = useState("");
  const [approvalstatus, setApprovalStatus] = useState("");
  const [rejectstatus, setRejectStatus] = useState("");
  const [appraisalId, setAppraisalId] = useState("");
  const [period,setPeriod]=useState("")

  const checkStatus = (empId, reqId) => async () => {
    const { data } = await axios(
      `${baseURL}/getappealstatusformember?aid=` +
        reqId +
        "&eid=" +
        empId
    );
    console.log("Fetched data:", data);
    if (Array.isArray(data.appealdata)) {
      let appr = data.appealdata[0];
      if (appr == undefined) {
        // alert("handleactgion new")
      } else {
        let approval = appr.approval;

        //alert("handleactgion called" +approval)
      }
    }
  };
  
  const handleAction = async (empId, reqId, appraisalid, actionType,period) => {
    setEmployeeId(empId);
    setRequestId(reqId);
    setAction(actionType);
    setAppraisalId(appraisalid);
    setPeriod(period)
    setApprovalStatus("");
    setRejectStatus("");
    const { data } = await axios(
      `${baseURL}/getappealstatusformember?aid=` +
        reqId +
        "&eid=" +
        id
    );
   
    if (Array.isArray(data.appealdata)) {
      let appr = data.appealdata[0];
      if (appr == undefined) {
        setShowStatustext(
          "Are you sure you would like to approve this appeal request"
        );
        setApprovalStatus("new");
        setAction("Approved");
      } else if (appr.approval == "Approved") {
        setShowStatustext("You have already approved his appeal request");
        setApprovalStatus("Approved");
        setAction("Rejected");
      } else if (appr.approval == "Rejected") {
        setShowStatustext("You have already Rejected his appeal request");
        setRejectStatus("Rejected");
        setAction("Approved");
      }
    }

    setShowModal(true);
    //    let status = getMemberAppealStatusforAppealid(empId, reqId, actionType);
    //    setApprovalStatus(status)
    //    if(status =="Approved")
    //    {
    //     setShowStatustext("You have already approved his appeal request");
    //    }
    //    else if(status =="Rejected")
    //    {
    //     setShowStatustext("You have already Rejected his appeal request");
    //    }
    //    if(status == "new")
    //    {
    //     setShowStatustext("Are you sure you would like to "+actionType+" this appeal request");
    //    }
  };

  const handleConfirm = async () => {
    // Perform action (approve or reject) based on the value of 'action'
    if (action === "Approved") {
      // Perform action for approval
      // For example, call a function to update the appeal request
      updateAppealRequest(employeeId, requestId, "Approved");
    } else if (action === "Rejected") {
      // Perform action for rejection
      // For example, call a function to update the appeal request
      updateAppealRequest(employeeId, requestId, "Rejected");
    }

    // Close the modal
    setShowModal(false);
  };

  useEffect(() => {
    const fetchPostList = async () => {
      try {
        const { data } = await axios(`${baseURL}/getappeals`);
        console.log("Fetched data:", data);
        if (Array.isArray(data.appeals)) {
          setPosts({ appeals: data.appeals });
          if (isAppealcommiteeMember === "Yes") {
            setHideAppealButtons(false);
          } else {
            setHideAppealButtons(true);
          }
        } else {
          console.error("Data is not an array:", data);
        }
      } catch (error) {
        console.error("Error fetching posts:", error);
      }
    };
    fetchPostList();
  }, []);
  const checkAppealFinalStatus = async (employeeId, appealreqid) => {
    const data1 = await axios.get(
      `${baseURL}/getappealcommmiteedecisoin?aid=` + appealreqid
    );
    let appealarr = data1.data.appealdecision[0];
    let empid = appealarr.employeeid;
    let appealstatus = appealarr.approval_status;
    // do insrert in appraisal status table
    checkandcreaterecord(appealstatus);
    updaterecord(appealstatus);
  };
  const checkandcreaterecord = async (appealstatus) => {
    try {
      if (appealstatus === "Appeal Approved") {
        const data2 = await axios.get(
          `${baseURL}/appealupdatefinalstatus?aid=` +
            appraisalId +
            "&eid=" +
            employeeId+
            "&period=" +
            period
        );

        //  setAppraisalId('');
      }
    } catch (error) {
      console.error("Error create record for apppal approval:", error);
    }
  };
  const updaterecord = async (appealstatus) => {
    try {
      if (appealstatus === "Appeal Approved") {
        const data2 = await axios.get(
          `${baseURL}/updateappeal?aid=` +
            appraisalId +
            "&id=" +
            employeeId +
            "&status=Approved"
        );

        //  setAppraisalId('');
      }
    } catch (error) {
      console.error("Error create record for apppal approval:", error);
    }
  };
  const updateAppealRequest = async (employeeid, appealreqid, status) => {
    try {
      if (status === "Approved") {
        const data = await axios.get(
          `${baseURL}/appealcommitteeapproval?id=` +
            id +
            "&appealreqid=" +
            appealreqid +
            "&status=" +
            status
        );
      } else if (status === "Rejected") {
        const data2 = await axios.get(
          `${baseURL}/appealcommitteereject?id=` +
            id +
            "&appealreqid=" +
            appealreqid +
            "&status=" +
            status
        );
      }
    } catch (error) {
      console.error("Error fetching posts:", error);
    }
    alert("Appeal request " + status);

    checkAppealFinalStatus(employeeId, appealreqid);
    // window.location='/appealapprovaltable';
  };

  useEffect(() => {
    const fetchAppealStatus = async () => {
      try {
        const { data } = await axios(
          `${baseURL}/getappealcommiteememberstatus?id=` + id
        );
        console.log("Fetched data:", data);
        if (Array.isArray(data.appealdata)) {
          let appr = data.appealdata[0];
          let approved = appr.approval;
          if (approved == "Approved") {
            setHideAppealButtons(true);
          }
        } else {
          console.error("Data is not an array:", data);
        }
      } catch (error) {
        console.error("Error fetching fetchAppealStatus:", error);
      }
    };
    fetchAppealStatus();
  }, []);

  // Get current posts
  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = posts.appeals.slice(indexOfFirstPost, indexOfLastPost);

  // Change page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Define handleCloseEditModal, handleCloseCommentModal, handleCloseViewModal functions

  return (
    <div>
      <div className="col-lg-12 d-flex mt-2 pb-3">
        <div className="col-lg-10">
          <h4 className="text-start">Appraisal Appeal Committee Approval </h4>
          As you are an appeal commitee member, you are authorized to review
          appeal requests
        </div>
        {/* <div className='col-lg-6 text-end bg-white '>
            <a href='choosetemplateform' className="text-decoration-none text-white" ><button type="button" class="btn btn-danger rounded-pill">Create Template +</button></a>
            </div> */}
      </div>
      <ReactBootstrap.Table striped bordered hover size="sm">
        <thead className="text-center">
          <tr>
            <th>#</th>
            <th>App. Req-Id</th>
            <th>Appraisal Id</th>
            <th>EMP-ID</th>
            <th>Employee Name</th>
            <th>Grade</th>
            <th>Reason for Appeal</th>
            <th>Appeal Oveall Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {currentPosts.map((appeals, index) => (
            <tr key={index}>
              <td>{index + 1}</td>
              <td>{appeals.appealrequesstid}</td>
              <td>{appeals.appraisalid}</td>
              <td>{appeals.employeeid}</td>
              <td>
                {appeals.FirstName} {appeals.LastName}
              </td>
              <td>{appeals.gradename}</td>
              <td>{appeals.reason}</td>
              <td>{appeals.approval_status}</td>

              {/* Action buttons */}
              <td className="text-center">
                <Button
                  className="border-0 bg-danger"
                  onClick={() =>
                    handleAction(
                      appeals.employeeid,
                      appeals.appealrequesstid,
                      appeals.appraisalid,
                      "new",
                      appeals.period
                    )
                  }
                >
                  Appeal Action 
                </Button>
                {/* <ReactBootstrap.Button className='border-0 bg-danger m-1'onClick={ updateAppealRequest(appeals.employeeid,appeals.appealrequesstid ,"Rejected")}  >&nbsp;&nbsp;Reject&nbsp;&nbsp;</ReactBootstrap.Button>
                                <ReactBootstrap.Button onClick={() => handleComment(skill)}>Comment</ReactBootstrap.Button> */}
              </td>
            </tr>
          ))}
        </tbody>
      </ReactBootstrap.Table>

      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirmation </Modal.Title>
        </Modal.Header>
        <Modal.Body>{showStatustext}</Modal.Body>
        <Modal.Footer>
          <Button
            variant="success"
            onClick={handleConfirm}
            disabled={
              approvalstatus === "Approved" || rejectstatus === "Rejected"
            }
          >
            Approve Appeal Request
          </Button>
          <Button
            variant="danger"
            onClick={handleConfirm}
            disabled={rejectstatus === "Rejected"}
          >
            Reject Appeal Request
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Pagination */}
      <ReactBootstrap.Pagination>
        {Array.from(
          { length: Math.ceil(posts.appeals.length / postsPerPage) },
          (_, index) => (
            <ReactBootstrap.Pagination.Item
              key={index}
              onClick={() => paginate(index + 1)}
            >
              {index + 1}
            </ReactBootstrap.Pagination.Item>
          )
        )}
      </ReactBootstrap.Pagination>
    </div>
  );
};

export default AppealApprovalTable;
